module.exports = __webpack_public_path__ + "img/chadle_adv_12.dba2339c.png";